import { render, staticRenderFns } from "./uf_available_results.vue?vue&type=template&id=4afcde27&scoped=true"
import script from "./uf_available_results.vue?vue&type=script&lang=js"
export * from "./uf_available_results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afcde27",
  null
  
)

export default component.exports